import React from 'react';
import {
  Field,
  TextInput,
  TextArea,
  RadioPair,
  ButtonGroup,
  TogglePill,
  SelectInput,
} from '../lib/FormControls';
import { APPLICATION_TYPE_OPTIONS, GENDER_OPTIONS, ID_TYPE_OPTIONS } from '../lib/fieldDefs';

export default function Step8Spouse({ form, setField }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Spouse / Secondary Insured</h2>
          <p className="text-sm text-gray-500">Include spouse on this application?</p>
        </div>
        <TogglePill
          enabled={form.has_spouse}
          onToggle={() => {
            const next = !form.has_spouse;
            setField('has_spouse', next);
            if (!next) setField('spouse_application_type', '');
          }}
        />
      </div>

      {form.has_spouse && (
        <>
          <Field label="Spouse Application Type" required>
            <ButtonGroup
              options={APPLICATION_TYPE_OPTIONS.map((o) => o.label)}
              value={
                APPLICATION_TYPE_OPTIONS.find((o) => o.value === form.spouse_application_type)
                  ?.label || ''
              }
              onChange={(label) => {
                const match = APPLICATION_TYPE_OPTIONS.find((o) => o.label === label);
                setField('spouse_application_type', match?.value || '');
              }}
            />
          </Field>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <Field label="Spouse Full Name" required>
              <TextInput
                value={form.spouse_full_name}
                onChange={(e) => setField('spouse_full_name', e.target.value)}
              />
            </Field>
            <Field label="Spouse Birth Date" required>
              <TextInput
                type="date"
                value={form.spouse_birth_date}
                onChange={(e) => setField('spouse_birth_date', e.target.value)}
              />
            </Field>
            <Field label="Spouse Gender" required>
              <ButtonGroup
                options={GENDER_OPTIONS}
                value={form.spouse_gender}
                onChange={(v) => setField('spouse_gender', v)}
              />
            </Field>
            <Field label="Spouse SSN" sensitive>
              <TextInput
                value={form.spouse_ssn}
                onChange={(e) => setField('spouse_ssn', e.target.value)}
              />
            </Field>
            <Field label="Spouse Citizenship">
              <TextInput
                value={form.spouse_citizenship}
                onChange={(e) => setField('spouse_citizenship', e.target.value)}
              />
            </Field>
            <Field label="Spouse ID Type">
              <SelectInput
                value={form.spouse_id_type}
                onChange={(e) => setField('spouse_id_type', e.target.value)}
                options={ID_TYPE_OPTIONS}
              />
            </Field>
            <Field label="Spouse ID Number">
              <TextInput
                value={form.spouse_id_number}
                onChange={(e) => setField('spouse_id_number', e.target.value)}
              />
            </Field>
            <Field label="Spouse ID State">
              <TextInput
                value={form.spouse_id_state}
                onChange={(e) => setField('spouse_id_state', e.target.value)}
              />
            </Field>
            <Field label="Spouse ID Expiration">
              <TextInput
                type="date"
                value={form.spouse_id_expiration}
                onChange={(e) => setField('spouse_id_expiration', e.target.value)}
              />
            </Field>
            <Field label="Spouse Coverage Amount">
              <TextInput
                value={form.spouse_coverage_amount}
                onChange={(e) => setField('spouse_coverage_amount', e.target.value)}
              />
            </Field>
            <Field label="Spouse Coverage Type">
              <TextInput
                value={form.spouse_coverage_type}
                onChange={(e) => setField('spouse_coverage_type', e.target.value)}
              />
            </Field>
            <Field label="Spouse Last Medical Visit">
              <TextInput
                value={form.spouse_last_medical_visit}
                onChange={(e) => setField('spouse_last_medical_visit', e.target.value)}
              />
            </Field>
            <Field label="Spouse Height">
              <TextInput
                value={form.spouse_height}
                onChange={(e) => setField('spouse_height', e.target.value)}
              />
            </Field>
            <Field label="Spouse Weight">
              <TextInput
                value={form.spouse_weight}
                onChange={(e) => setField('spouse_weight', e.target.value)}
              />
            </Field>
            <Field label="Spouse Weight Change 10lbs">
              <RadioPair
                value={form.spouse_weight_change_10lbs}
                onChange={(v) => setField('spouse_weight_change_10lbs', v)}
              />
            </Field>
            <Field label="Spouse Is Smoker">
              <RadioPair
                value={form.spouse_is_smoker}
                onChange={(v) => setField('spouse_is_smoker', v)}
              />
            </Field>
            <Field label="Spouse Other Specialists">
              <RadioPair
                value={form.spouse_other_specialists_5yr}
                onChange={(v) => setField('spouse_other_specialists_5yr', v)}
              />
            </Field>
            <Field label="Spouse International Travel">
              <RadioPair
                value={form.spouse_international_travel}
                onChange={(v) => setField('spouse_international_travel', v)}
              />
            </Field>
            <Field label="Spouse Dangerous Activities">
              <RadioPair
                value={form.spouse_dangerous_activities}
                onChange={(v) => setField('spouse_dangerous_activities', v)}
              />
            </Field>
            <Field label="Spouse Unpaid Tickets">
              <RadioPair
                value={form.spouse_unpaid_tickets}
                onChange={(v) => setField('spouse_unpaid_tickets', v)}
              />
            </Field>
            <Field label="Spouse Exercises Regularly">
              <RadioPair
                value={form.spouse_exercises_regularly}
                onChange={(v) => setField('spouse_exercises_regularly', v)}
              />
            </Field>
          </div>
          <Field label="Spouse Health Provider">
            <TextArea
              rows={3}
              value={form.spouse_health_provider}
              onChange={(e) => setField('spouse_health_provider', e.target.value)}
            />
          </Field>
          <Field label="Spouse Medications 5yr">
            <TextArea
              rows={3}
              value={form.spouse_medications_5yr}
              onChange={(e) => setField('spouse_medications_5yr', e.target.value)}
            />
          </Field>
          {form.spouse_other_specialists_5yr === 'Yes' && (
            <Field label="Spouse Other Specialists Detail">
              <TextArea
                rows={3}
                value={form.spouse_other_specialists_detail}
                onChange={(e) => setField('spouse_other_specialists_detail', e.target.value)}
              />
            </Field>
          )}
          <Field label="Spouse Health Conditions">
            <TextArea
              rows={3}
              value={form.spouse_health_conditions}
              onChange={(e) => setField('spouse_health_conditions', e.target.value)}
            />
          </Field>
        </>
      )}
    </div>
  );
}
